import { SME_OFFER_EVENT } from "../../../api-client/src/constants/util";
import { commonProfHandler } from "./commonProfHandler";

export const lflHandler = commonProfHandler({
  productCode: "LFL",
  productName: "LAWYER",
  eventCode: SME_OFFER_EVENT,
});
